import { createSlice } from "@reduxjs/toolkit";

export const tempCartSlice = createSlice({
  name: "tempCart",
  initialState: [],
  reducers: {
    addCartItem: (state, action) => {
      state.push(action.payload);
      return state;
    },
    deleteCartItem: (state, action) => {
      return state.filter((item) => item.id !== action.payload);
    },
    editCartItem: (state, action) => {
      const itemIndex = state.findIndex(
        (item) => item.id === action.payload.id
      );
      if (itemIndex !== -1) {
        state[itemIndex] = {
          ...state[itemIndex],
          ...action.payload,
        };
        return state;
      }
      return state;
    },
    quantityChange: (state, action) => {
      const itemIndex = state.findIndex(
        (item) => item.id === action.payload.cartItemId
      );
      if (itemIndex !== -1) {
        state[itemIndex].qty = action.payload.qty;
        return state;
      }
      return state;
    },
    clearCart: (state) => {
      return [];
    },
  },
});

export const {
  addCartItem,
  deleteCartItem,
  editCartItem,
  quantityChange,
  clearCart,
} = tempCartSlice.actions;
